import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';

import { NzTagModule } from 'ng-zorro-antd/tag';

import { TranslateModule } from '@ngx-translate/core';

import { Alert } from '@app/alerts/state/alerts-state.models';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

@Component({
  selector: 'adspt-alerts-status-label',
  templateUrl: './alerts-status-label.component.html',
  styleUrls: ['./alerts-status-label.component.scss'],
  imports: [forwardRef(() => SharedDirectivesModule), NgIf, NgSwitch, NgSwitchCase, TranslateModule, NzTagModule],
})
export class AlertsStatusLabelComponent {
  @Input()
  alert?: Alert;
}
